export const AVAILABLE_LANGUAGES = ["en", "nl", "fr"];
